import { render, staticRenderFns } from "./bulma_subtabprops.vue?vue&type=template&id=0cadff08&scoped=true"
import script from "./bulma_subtabprops.vue?vue&type=script&lang=js"
export * from "./bulma_subtabprops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cadff08",
  null
  
)

export default component.exports